/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_ASSETS = gql`
query Query($size: Int, $offset: Int, $filter:AssetFilter) {
    getAssets(size: $size, offset: $offset, filter:$filter)  {
      data {
        idx
        title
        subtitle
        serialNo
        scAddress
        img
        thumbnail
        category
        tokenGroup
        scAddress
        networkType
        type
        price {
          type
          amount
          currency
          sale {
            salePrice
            saleEndDate
          }
          symbol
        }
      }
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
`